import { grid } from "@styled-system/patterns";

export const videoInputContainerClass = grid({
	gridTemplateColumns: "[1fr 1fr]",
});
